module.exports = __webpack_public_path__ + "img/CompScope_Bright_08.9cb2c810.png";